import '~/glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';

const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
});
